import api from '../../utils/axios';
import { API_ROUTES } from '../../constants/apiRoutes';

/**
 * Fetch paginated Company Directory with Call Status and Technology aggregations
 */
export const getCompanyReportApi = async ({
  search,
  startDate,
  endDate,
  technology,
  callStatus,
  isMerge,
  page = 1,
  size = 10,
  sortBy = 'name',
  sortOrder = 'ASC'
}) => {
  try {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (technology) params.append('technology', technology);
    if (callStatus) params.append('callStatus', callStatus);
    if (isMerge) params.append('isMerge', isMerge);
    params.append('page', page);
    params.append('size', size);
    params.append('sortBy', sortBy);
    params.append('sortOrder', sortOrder);

    const response = await api.get(`${API_ROUTES.COMPANY_REPORT}?${params.toString()}`);

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Merge one or more company records into a master company collection
 */
export const mergeCompaniesApi = async (payload) => {
  try {
    const response = await api.post(API_ROUTES.COMPANY_MERGE, payload);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Search companies for async autocomplete (searches both master name and aliases)
 */
export const searchCompanyApi = async (query) => {
  try {
    const response = await api.get(
      `${API_ROUTES.COMPANY_SEARCH}?query=${encodeURIComponent(query || '')}`
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Create a new Master Company
 */
export const createMasterCompanyApi = async (companyData) => {
  try {
    const response = await api.post(API_ROUTES.COMPANY_CREATE, companyData);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Update an existing Master Company (Name, Aliases)
 */
export const updateMasterCompanyApi = async (companyId, companyData) => {
  try {
    const response = await api.put(`${API_ROUTES.COMPANY_DETAILS}/${companyId}`, companyData);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Check if a Master Company name already exists in database
 */
export const checkCompanyNameApi = async (name, excludeId = null) => {
  try {
    const params = new URLSearchParams();
    if (name) params.append('name', name);
    if (excludeId) params.append('excludeId', excludeId);
    const response = await api.get(`${API_ROUTES.COMPANY_CHECK_NAME}?${params.toString()}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
